import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';
import {map, tap} from 'rxjs/internal/operators';
import {ToastController} from '@ionic/angular';
import {StorageService} from './storage.service';
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  toast: any;
  isLoggedIn = false;
  token: any;
  actionUrl = environment.baseUrl;
    httpOptions : any;
  constructor(private http: HttpClient, private toastCtrl: ToastController, private storage: StorageService) {

  }

  login(name: string, password: string) {
    return this.http.post(this.actionUrl + 'login',
        {name, password}, this.httpOptions
    ).pipe(map(data => {
        data = data['user'];
        this.token = data['api_token'];
        this.storage.setString('token_difritz',this.token);
        data['dp']=password;
        delete data['api_token'];
        delete data['created_at'];
        delete data['deleted_at'];
        delete data['updated_at'];
        this.storage.setObject('user_difritz',data);
        this.isLoggedIn = true;
        }),
    );
  }

    async getToken() {
        const { value } = await this.storage.getString("token_difritz");
        return value;
    }


  logout(){
      this.httpOptions = {
          headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + this.token
          })
      };
      return this.http.post(this.actionUrl + 'logout', {}, this.httpOptions)
        .pipe(map(token => {
            this.storage.removeItem('token_difritz');
            this.token = '';
              this.isLoggedIn = false;
            }),
        );
  }
}
